// extracted by mini-css-extract-plugin
export default {"productGrid":"b0-z","centerLink":"c0-z","productSection":"d0-z","item":"e0-z","ctaButton":"f0-z"};